/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { ActorRoleResponse } from "../../roles/types/ActorRoleResponse";
import { User } from "./User";
export const UserWithRoles = core.serialization
    .object({
    actorRoles: core.serialization.list(ActorRoleResponse),
})
    .extend(User);
